/* eslint-disable */
import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { RELATIONSHIP_WITH_BORROWER } from '../../../../../../framework/constants/profile';
// const interceptor = {
//   key: 'default',
//   call: ({ change }: any) => {
//     if (change.newValue !== null && change.newValue !== undefined) {
//       return change;
//     }
//     change.newValue = '';
//     return change;
//   }
// };
// const createDropDownInterceptor = (values: any) => ({
//   key: 'default',
//   call: ({ change }: any) => {
//     const value = values.find(({ value }: any) => value === change.newValue);
//     change.newValue = value !== undefined ? value : '';
//     return change;
//   }
// });
export const fields = [
    {
        name: 'firstName',
        label: 'CheckoutPage:contactInformation:fieldLabels.firstName',
        rules: 'required|string|firstName',
        value: ''
        // interceptors: [interceptor]
    },
    {
        name: 'lastName',
        label: 'CheckoutPage:contactInformation:fieldLabels.lastName',
        rules: 'required|string|lastName',
        value: ''
        // interceptors: [interceptor]
    },
    {
        name: 'email',
        label: 'CheckoutPage:contactInformation:fieldLabels.email',
        rules: 'required|email|borrower_email',
        value: ''
        // interceptors: [interceptor]
    },
    {
        name: 'birthday',
        label: 'CheckoutPage:contactInformation:fieldLabels.birthday',
        rules: 'required|dd/MM/yyyy',
        value: null
    },
    {
        name: 'borrower',
        label: 'CheckoutPage:contactInformation:fieldLabels.borrower',
        rules: 'required',
        value: '',
        extra: RELATIONSHIP_WITH_BORROWER
        // interceptors: [createDropDownInterceptor(RELATIONSHIP_WITH_BORROWER)]
    }
];
const hooks = {
    onSuccess: () => { }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
/* eslint-enable */
